module.exports = __webpack_public_path__ + "static/4-6c1b8f0e90d62bb7c40481bec0d6d4bf.jpg";